import { render, staticRenderFns } from "./NotificationListItemContent.vue?vue&type=template&id=452eb7c0&scoped=true"
import script from "./NotificationListItemContent.vue?vue&type=script&lang=js"
export * from "./NotificationListItemContent.vue?vue&type=script&lang=js"
import style0 from "./NotificationListItemContent.vue?vue&type=style&index=0&id=452eb7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452eb7c0",
  null
  
)

export default component.exports